import { Select } from '@lifebit-ai/lds'
import React from 'react'

import type { DownloadExpiryOption } from 'modules/resultsV2/downloadExpiry.types'

import { DownloadExpiryKeys } from '../enums'
import * as styles from './DownloadExpirySelector.styles'

interface DownloadExpirySelectorProps {
  options: Record<DownloadExpiryKeys, DownloadExpiryOption>
  value: string
  onChange: (downloadExpiryOptionKey: DownloadExpiryKeys) => void
}

const DownloadExpirySelector: React.FC<DownloadExpirySelectorProps> = ({ options, value, onChange }) => {
  return (
    <styles.Container>
      <Select
        label="Download expiry"
        helpText="The amount of time before a download link expires."
        value={value}
        options={Object.entries(options).map(([key, option]) => {
          return {
            value: key,
            label: option.label
          }
        })}
        onChange={value => onChange(parseInt(value))}
      />
    </styles.Container>
  )
}

export default DownloadExpirySelector
